import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Modal, message } from "ant-design-vue";
import Vue from "vue";
// 组件实例

import Component from "@/core/component/index";
import tools from "@/pages/design/tools/tools";
import toolsm from "@/pages/design/tools/toolsm";
import config from '@/config';
import { api2VmToolItem, getComponentTemplates, getComponentsAndInitToolsConfig, getComponentMap } from "@/pages/design/common/utils";
import { moveUpAt, moveDownAt } from "@/pages/design/common/array";
import { designPublish, designSave, designBulletinBoardInfo, designPublicData, designGetProductList } from "@/services/design";
import alllang from '@/pages/design/locales/alllang';
import messages from '@/pages/design/design_i18n';
import VueI18n from 'vue-i18n';

// 多语言
var i18n = new VueI18n({
  locale: window.localStorage.lang || config.lang,
  messages: messages.messages
});
function checkMainTitle(components) {
  // 检测公共栏的主标题是否填写了

  var defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
  var vdc = components.find(function (vdc) {
    return vdc.name === 'Notice';
  });
  if (vdc && defaultLangObj) {
    var value = vdc.componentValue;
    if (value.status && !value.main.title[defaultLangObj.langId]) {
      message.error(i18n.t('form.mainTitle_placeholder2'));
      return false;
    }
  }
  return true;
}
// 装修页模块
var design = {
  namespaced: true,
  state: {
    first_loaded: false,
    // 首次加载是否成功
    loading: false,
    // 页面是否加载中
    preview_in_drag: false,
    // 预览区域是否在拖拽中
    selected_vdc: null,
    // 选中的组件数据对象，打开form表单
    show_component_form: false,
    // 是否展示组件配置项,
    // component_temlate_list: [], // 所有组件的模版列表
    selected_id: 0,
    components: [],
    componentGroup: [],
    componentTemplates: [],
    scale: 75,
    maxScale: 200,
    minScale: 45,
    platform: "pc",
    rootSize: "140px",
    imgHost: '',
    // 图片 host
    lastupdatetime: '',
    langList: '',
    langId: '',
    langCode: '',
    formEdited: false,
    // form是否编辑的标志位
    lastNoticeInfo: null,
    // 上次保存的公告栏内容，用来根据公告栏内容有没有改变去更新公共栏的updateTime
    clientPublicData: null,
    // C端PublicData
    designSaveLoading: false,
    designPublishLoading: false
    // goods_
  },
  mutations: {
    setShowForm: function setShowForm(state) {
      if (!state.selected_id) return;
      state.show_component_form = true;
    },
    setHideForm: function setHideForm(state) {
      state.show_component_form = false;
    },
    /**
     * 更新所有组件的模版列表
     * @param {Object} state
     * @param {Array} list 模版列表
     */
    // udpate_component_template_list (state, list) {
    //     state.component_temlate_list = list;
    // },
    /**
     * 添加页面组件
     * @param {Number} index
     * @param {Vdc} component
     */
    setComponentGroup: function setComponentGroup(state, data) {
      state.componentGroup = data;
    },
    setComponentTemplates: function setComponentTemplates(state, data) {
      // console.log('data', data)
      state.componentTemplates = data;
    },
    set_selected_component: function set_selected_component(state, data) {
      // console.log("set_selected_conponent");
      state.selected_id = data.id;
      state.selected_vdc = data;
    },
    set_scale: function set_scale(state, data) {
      var num = parseInt(data);
      if (num > state.maxScale) {
        num = state.maxScale;
      }
      ;
      if (num < state.minScale) {
        num = state.minScale;
      }
      ;
      state.scale = num;
    }
  },
  getters: {
    getComponentTitles: function getComponentTitles(state) {
      var titles = state.components.map(function (item) {
        return {
          label: item.component_title,
          value: item.id
        };
      });
      // console.log("titles", titles);
      return titles;
    },
    /* getComponentGroup(state){
     *   let templates = []
     *   if (state.platform === 'm'){
       templates = getComponentTemplates(toolsm)
     *   }else {
       templates = getComponentTemplates(tools)
     *   }
     *   return templates
     * } */
    curComponentNum: function curComponentNum(state) {
      var curp = state.platform == "m" ? 1 : 2;
      var list = state.components.reduce(function (pre, cur) {
        if (cur.location === 0 || cur.location == curp) {
          pre[cur.name] = pre[cur.name] ? pre[cur.name] + 1 : 1;
        }
        return pre;
      }, {});
      return list;
    },
    getPlatform: function getPlatform(state) {
      var p = window.localStorage.platform;
      if (p && p != state.platform) {
        return p;
      }
      return state.platform;
    }
  },
  actions: {
    setEdited: function setEdited(_ref) {
      var state = _ref.state,
        dispatch = _ref.dispatch;
      dispatch('setIntercept');
      state.formEdited = true;
    },
    setFormEdited: function setFormEdited(_ref2) {
      var state = _ref2.state,
        dispatch = _ref2.dispatch;
      if (!state.show_component_form) return;
      // 增加拦截
      dispatch('setIntercept');
      state.formEdited = true;
    },
    setPlatform: function setPlatform(_ref3, data) {
      var state = _ref3.state,
        dispatch = _ref3.dispatch;
      window.localStorage.setItem("platform", data);
      state.platform = data;
      state.first_loaded = false;

      /* dispatch('page_load') */
      dispatch("setPlatformData"); // 左侧组件列表加载 缩放 各自端的所有组件列表
      dispatch("setComponentPack"); // 切换显示端时重新设置各自的View

      dispatch("pageInit");
      state.first_loaded = true;
    },
    pageInit: function pageInit(_ref4) {
      var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;
      // state.first_loaded = false;
      // // commit('page/setPlatform', 'pc')
      // // 初始化表单状态
      // state.selected_id = null;
      // // document.documentElement.style.fontSize = state.rootSize
      // state.show_component_form = false;

      if (state.selected_id) {
        var index;
        var c = state.components.filter(function (item, i) {
          if (item.id === state.selected_id) {
            index = i;
            return true;
          }
        })[0];
        if (!c || c.platform !== state.platform) {
          state.selected_id = null;
          state.show_component_form = false;
        } else {
          if (c && index) {
            setTimeout(function () {
              dispatch('component_locate_by_floor', {
                component: c,
                index: index
              });
            }, 0);
          }
        }
      } else {
        setTimeout(function () {
          dispatch('component_locate_by_floor', {});
        }, 0);
      }
      state.rootSize = state.platform == "pc" ? "140px" : "37.5px";
      //
      // let i18n = state.platform == 'pc' ? pcI18n : mI18n
      //
      // i18n.locale = state.langCode
      //
      // Vue.prototype.$vI18n = i18n
      // Vue.prototype.$t = i18n.t.bind(i18n)
      //

      /* dispatch('page_load')  */
    },
    componentMoveUp: function componentMoveUp(_ref5, id) {
      var state = _ref5.state;
      var c_index;
      state.components.forEach(function (item, i) {
        if (item.id === id) {
          c_index = i;
        }
      });
      if (typeof c_index !== 'undefined') {
        moveUpAt(state.components, c_index);
      }
    },
    componentMoveDown: function componentMoveDown(_ref6, id) {
      var state = _ref6.state;
      var c_index;
      state.components.forEach(function (item, i) {
        if (item.id === id) {
          c_index = i;
        }
      });
      if (typeof c_index !== 'undefined') {
        moveDownAt(state.components, c_index);
      }
    },
    componentDup: function componentDup(_ref7, id) {
      var state = _ref7.state,
        getters = _ref7.getters;
      try {
        // debugger
        var index;
        var component = state.components.filter(function (item, i) {
          if (item.id === id) {
            index = i;
            return true;
          }
        })[0];
        var vdc = component.duplicate();
        state.components.splice(index + 1, 0, vdc);
        message.success(i18n.t('stateDesign.copySuccess'));
      } catch (err) {
        console.log('err', err);
        message.error(i18n.t('stateDesign.copyError'));
      }
    },
    /**
     * 删除1个页面组件
     * @param {Int} component_id
     */
    componentDelete: function componentDelete(_ref8, component_id) {
      var state = _ref8.state,
        dispatch = _ref8.dispatch;
      Modal.confirm({
        title: i18n.t('stateDesign.deleteAsk'),
        onOk: function onOk() {
          state.components = state.components.filter(function (x) {
            return x.id !== component_id;
          });
          dispatch('setEdited');
          dispatch("form_close");
          message.success(i18n.t('stateDesign.deleteSuccess'));
        }
      });
    },
    set_scale_minus: function set_scale_minus(_ref9) {
      var state = _ref9.state,
        commit = _ref9.commit;
      var num = state.scale;
      num -= 5;
      commit("set_scale", num);
    },
    set_scale_plus: function set_scale_plus(_ref0) {
      var state = _ref0.state,
        commit = _ref0.commit;
      var num = state.scale;
      num += 5;
      commit("set_scale", num);
    },
    /**
     * 打开form表单
     * @param {Number} id 组件ID
     */
    form_open: function form_open(_ref1, id) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, dispatch, target;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref1.state, dispatch = _ref1.dispatch;
              // 根据ID找到对应的组件
              target = state.components.find(function (x) {
                return x.id === id;
              }); // 展示 form
              state.selected_vdc = null;
              state.selected_vdc = target;
              state.selected_id = id;

              // state.formEdited = true
              state.show_component_form = true;
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 关闭表单
     */
    form_close: function form_close(_ref10) {
      var state = _ref10.state;
      state.show_component_form = false;
    },
    /**
     * 中间预览区域，定位到对应的组件楼层
     * @param {Vdc} component 组件
     * @param {Number} index 组件楼层
     */
    component_locate_by_floor: function component_locate_by_floor(_ref11, _ref12) {
      var commit = _ref11.commit,
        state = _ref11.state;
      var component = _ref12.component,
        index = _ref12.index;
      // const dom = document.getElementById(component.id);
      var middleDom = document.getElementById("design-middle-layout");
      if (!component) {
        middleDom.scrollTop = 0;
        return;
      }
      var dom = document.querySelector(".component_" + component.id);

      // console.log("item", dom);
      if (!dom) return false;

      // 获取元素的纵坐标（相对于窗口）
      function getTop(e) {
        var offset = e.offsetTop;
        if (e.offsetParent != null) offset += getTop(e.offsetParent);
        return offset;
      }
      var top = index == 0 ? 0 : getTop(dom);
      var p = state.scale / 100;
      middleDom.scrollTop = top * p - 100 * p;
      commit("set_selected_component", component);
    },
    setIntercept: function setIntercept() {
      window.onbeforeunload = function () {
        return "aaa";
      };
    },
    clearIntercept: function clearIntercept() {
      window.onbeforeunload = null;
    },
    /**
     * 页面加载
     * @param {object} request  页面参数
     */
    registerComponents: function registerComponents(context) {
      var m_components = getComponentsAndInitToolsConfig(toolsm);
      // debugger
      for (var _i = 0, _Object$entries = Object.entries(m_components); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        Vue.component(key, value);
      }

      // 注册组件
      var components = getComponentsAndInitToolsConfig(tools, "PC");
      for (var _i2 = 0, _Object$entries2 = Object.entries(components); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];
        //ViewNoticePc
        Vue.component(_key, _value);
      }
    },
    /* loadComponentGroup({commit}){
     *   let group = getComponentGroup()
     *   commit('setComponentgroup', group)
     * }, */
    setPlatformData: function setPlatformData(_ref13) {
      var state = _ref13.state,
        commit = _ref13.commit;
      var templates = [];
      if (state.platform === "m") {
        templates = getComponentTemplates(toolsm);
        commit("setComponentGroup", toolsm);
        commit("set_scale", 100);
      } else {
        templates = getComponentTemplates(tools);
        commit("setComponentGroup", tools);
        commit("set_scale", 75);
      }
      commit("setComponentTemplates", templates);
    },
    setComponentPack: function setComponentPack(_ref14) {
      var state = _ref14.state;
      var componentMap1 = getComponentMap(tools);
      var componentMap2 = getComponentMap(toolsm);

      // debugger
      // const componentMap = [...componentMap1, ...componentMap2]

      var componentMap = {};
      for (var _i3 = 0, _Object$keys = Object.keys(componentMap1); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        componentMap[key] = componentMap1[key];
      }
      for (var _i4 = 0, _Object$keys2 = Object.keys(componentMap2); _i4 < _Object$keys2.length; _i4++) {
        var _key2 = _Object$keys2[_i4];
        componentMap[_key2] = componentMap2[_key2];
      }
      var arr = [];
      state.components.forEach(function (item, i) {
        var map;
        map = componentMap[state.platform + item.name];
        // 如果没有找到map 就跳过这一个
        if (!map) return;
        item.componentPack = map.componentPack;
        item["platform"] = state.platform;
        arr.push(item);
        Vue.set(state.components, i, item);
        /* let obj = _.cloneDeep(item); */
        /* obj.componentPack = map.componentPack; */

        /*         console.log("obj", obj); */

        /* 	 Vue.set(state.components, i, obj) */

        /*         state.components.splice(i, 1, obj); */
      });

      /* state.components = arr */

      // 现在版本不用在切换显示端后回到顶部

      //     setTimeout(() => {

      // 	const middleDom = document.getElementById("design-middle-layout");

      //     if(middleDom){

      // middleDom.scrollTo({top: 0, x: 0, behavior: 'smooth' })

      //     }
      //     }, 0)

      /* state.components = JSON.parse(JSON.stringify(state.components)) */
    },
    page_load: function page_load(_ref15, page_platform) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, dispatch, commit, defaultLangObj, basicParams, publicData, info, list, _publicData$data$data, langId, langList, noticeInfo, navbarInfo, navigatorInfo, footerInfo, host, lastupdatetime, cdefaultLangObj, lang, goodsCom, _iterator, _step, item, res, dataList, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref15.state, dispatch = _ref15.dispatch, commit = _ref15.commit;
              state.loading = true;

              // let xhrSend = XMLHttpRequest.prototype.send
              //
              // XMLHttpRequest.prototype.send = function (req){
              //     console.log('AAAA req', req)
              //     xhrSend.apply(this, req)
              // }

              if (!localStorage.platform) {
                localStorage.setItem('platform', state.platform);
              }
              defaultLangObj = localStorage.defaultLangObj;
              defaultLangObj = JSON.parse(defaultLangObj || '{}');
              basicParams = {
                plate: 2,
                langId: defaultLangObj.langId || 2,
                clientType: 1
              };
              _context2.n = 1;
              return designPublicData(basicParams);
            case 1:
              publicData = _context2.v;
              _context2.n = 2;
              return designBulletinBoardInfo(basicParams);
            case 2:
              info = _context2.v;
              if (publicData.data.code === 200) {
                state.clientPublicData = publicData.data.data;
              }
              list = info.data.data.list;
              _publicData$data$data = publicData.data.data, langId = _publicData$data$data.langId, langList = _publicData$data$data.langList, noticeInfo = _publicData$data$data.noticeInfoNew, navbarInfo = _publicData$data$data.navbarInfo, navigatorInfo = _publicData$data$data.navigatorInfoNew, footerInfo = _publicData$data$data.footerInfo, host = _publicData$data$data.host, lastupdatetime = _publicData$data$data.lastupdatetime;
              state.langList = langList;
              state.langId = langId;
              state.lastNoticeInfo = _.cloneDeep(noticeInfo);
              cdefaultLangObj = {};
              cdefaultLangObj.langId = langId;
              window.localStorage.cdefaultLangObj = JSON.stringify(cdefaultLangObj);
              lang = alllang[langId];
              state.langCode = lang;
              localStorage.setItem('langCode', lang);
              state.imgHost = host;
              state.lastupdatetime = lastupdatetime;
              list.unshift(navigatorInfo);
              list.unshift(navbarInfo);
              list.unshift(noticeInfo);
              list.push(footerInfo);

              /*
              designGetProductList({
                      moduleId: item.id,
                      langId: langId,
                      plate: 2,
                      clentType: 1,
                  }).then(res => res.data)
                      .then(res => {
                          item.value.productList = res.data.productList
                      })
               */

              // 商品列表处理
              goodsCom = list.filter(function (item) {
                return item.name === 'Goodslist';
              });
              _iterator = _createForOfIteratorHelper(goodsCom);
              _context2.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context2.n = 7;
                break;
              }
              item = _step.value;
              _context2.n = 5;
              return designGetProductList({
                moduleId: item.id,
                langId: langId,
                plate: 2,
                clentType: 1
              });
            case 5:
              res = _context2.v;
              item.value.productList = res.data.data.productList;
            case 6:
              _context2.n = 4;
              break;
            case 7:
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              _iterator.e(_t);
            case 9:
              _context2.p = 9;
              _iterator.f();
              return _context2.f(9);
            case 10:
              dataList = [];
              dataList = api2VmToolItem(tools, toolsm, list);
              /* let dataList = api2VmToolItem(tools, toolsm, datasm); */
              /* debugger */
              dispatch("setPlatformData");

              // debugger
              state.components = dataList.map(function (x) {
                return new Component(x);
              });
              state.loading = false;
              state.first_loaded = true;
            case 11:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 8, 9, 10]]);
      }))();
    },
    /**
     * 页面保存函数
     * @author Cullen
     * @date 2019-11-26
     */
    page_save: function page_save(_ref16) {
      var state = _ref16.state,
        rootState = _ref16.rootState,
        dispatch = _ref16.dispatch;
      if (!checkMainTitle(rootState.design.components)) {
        console.log('false');
        return Promise.reject('notip');
      }
      // 开启 loading 状态
      state.loading = true;
      return new Promise(function (resolve, reject) {
        // 删除部分不需要传输到后端的字段
        // let cmpts_arr = JSON.parse(JSON.stringify(rootState.page.components));
        var cmpts_arr = rootState.design.components.map(function (vdc) {
          /* if (vdc.name === "Goodslist") {
          *   delete vdc.componentValue.productList;
          * } */
          // vdc.inject_remote_data();
          var copy_vdc = JSON.parse(JSON.stringify({
            id: vdc.id,
            name: vdc.name,
            value: vdc.componentValue
          }));
          if (copy_vdc.name === 'Goodslist' && copy_vdc.value.productList) {
            // copy_vdc.value.product = copy_vdc.value.productList.map(item => item.productSpecificationId)

            copy_vdc.value.productList = [];
          }
          if (copy_vdc.name === 'Banner' && copy_vdc.value.pathLink) {
            var pathLinks = copy_vdc.value.pathLink;
            var _iterator2 = _createForOfIteratorHelper(pathLinks),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;
                item.productList = [];
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          // 对比公共栏内容更新updateTime
          if (copy_vdc.name === 'Notice') {
            var lastContent = JSON.stringify({
              pathlink: state.lastNoticeInfo.value.pathLink,
              main: state.lastNoticeInfo.value.main.title,
              sub: state.lastNoticeInfo.value.sub.title
            });
            var currentContent = JSON.stringify({
              pathlink: copy_vdc.value.pathLink,
              main: copy_vdc.value.main.title,
              sub: copy_vdc.value.sub.title
            });
            if (lastContent !== currentContent) {
              console.log('改变了');
              vdc.componentValue.updateTime = copy_vdc.value.updateTime = state.lastupdatetime;
            }
            state.lastNoticeInfo = copy_vdc;
          }
          return copy_vdc;
        });

        // localStorage.setItem('layouts', JSON.stringify(cmpts_arr));

        // 保存的参数
        var saveParams = {
          // pageTitle: rootState.page.info.title,
          // lang: rootState.page.info.lang,
          // pageId: rootState.page.info.page_id,
          // platform: rootState.page.info.platform,
          components: cmpts_arr
        };
        if (state.designSaveLoading) return;
        state.designSaveLoading = true;
        designSave({
          components: saveParams,
          lastupdatetime: state.lastupdatetime
        }).then(function (res) {
          if (res.data.code === 200) {
            state.lastupdatetime = res.data.data.lastupdatetime;

            // 保存成功后清除拦截
            dispatch('clearIntercept');
            state.formEdited = false;
            resolve(res);
          } else {
            reject(res);
          }
        }).catch(function (res) {
          reject(res);
        }).finally(function () {
          state.loading = false;
          state.designSaveLoading = false;
        });
      });
    },
    page_publish: function page_publish(_ref17) {
      var dispatch = _ref17.dispatch,
        state = _ref17.state,
        rootState = _ref17.rootState;
      if (!checkMainTitle(rootState.design.components)) {
        return Promise.reject(i18n.t('form.mainTitle_placeholder2'));
      }
      dispatch("page_save").then(function (res) {
        if (state.designPublishLoading) return;
        state.designPublishLoading = true;
        designPublish().then(function (res) {
          return res.data;
        }).then(function (res) {
          if (res.code == 200) {
            state.formEdited = false;
            message.success(i18n.t('stateDesign.publishSuccess'));
          } else {
            message.error(i18n.t('stateDesign.publishError'));
          }
        }).finally(function () {
          state.designPublishLoading = false;
        });
      }).catch(function (res) {
        console.log(res);
        message.error(i18n.t('stateDesign.saveError'));
      });
    },
    /**
     * 清除页面组件
     */
    page_reset: function page_reset(_ref18) {
      var state = _ref18.state;
      state.components = state.components.filter(function (item) {
        // return /Notice|Navbar|Menubar|Footer/.test(item.name) == true
        return item.draggable === false;
      });

      // 弹层
      /* Modal.confirm({
       *   title: "确认删除所有组件？",
       *   onOk() {
       *     state.components = [];
       *   },
       * }); */
    },
    insertComponent: function insertComponent(_ref19, _ref20) {
      var state = _ref19.state,
        dispatch = _ref19.dispatch;
      var index = _ref20.index,
        newIndex = _ref20.newIndex,
        component = _ref20.component;
      var headerArr = state.components.splice(0, 3);
      var len = state.components.length;
      var footerArr = [];
      if (len && state.components[len - 1].name == 'Footer') {
        footerArr = state.components.splice(len - 1, 1);
      }

      /* state.components.splice(newIndex, 1); */

      index = typeof index === "undefined" ? newIndex : index;
      var before = state.components.slice(0, index);
      var after = state.components.slice(index);
      var arr = [].concat(_toConsumableArray(headerArr), _toConsumableArray(before), [component], _toConsumableArray(after), _toConsumableArray(footerArr));
      /* let arr = [...before, component, ...after] */

      state.components = arr;

      // 将插入的组件移动到视野中
      var endIndex = arr.indexOf(component);
      setTimeout(function () {
        dispatch("component_locate_by_floor", {
          component: component,
          index: endIndex
        });
      }, 0);
    },
    /**
     * 页面插入1个组件
     * @param {String} component_key 组件编码
     * @param {Number} index 位置
     */
    add_page_component: function add_page_component(_ref21, _ref22) {
      var commit = _ref21.commit,
        dispatch = _ref21.dispatch,
        state = _ref21.state;
      var name = _ref22.name,
        title = _ref22.title,
        componentPack = _ref22.componentPack,
        draggable = _ref22.draggable,
        order = _ref22.order,
        maxNum = _ref22.maxNum,
        newIndex = _ref22.newIndex,
        index = _ref22.index,
        type = _ref22.type,
        platform = _ref22.platform;
      if (name === "Index") {
        var list = state.components.filter(function (item) {
          return item.name === "Goodslist";
        });
        var indexList = state.components.filter(function (item) {
          return item.name === "Index";
        });
        if (!list.length) {
          // state.components.splice(newIndex, 1);
          message.warning(i18n.t('stateDesign.addGoods'));
          return;
        }
        if (indexList.length > 0) {
          // state.components.splice(newIndex, 1);
          message.warning(i18n.t('stateDesign.onlyIndex'));
          return;
        }
      }
      var newComponent = new Component({
        name: name,
        title: title,
        componentPack: componentPack,
        order: order,
        maxNum: maxNum,
        draggable: draggable,
        platform: platform,
        type: type,
        // location,
        componentValue: {}
      });
      var newnewIndex = order ? order == "footer" ? state.components.length - 1 : order - 1 : undefined;
      dispatch("insertComponent", {
        index: newnewIndex,
        newIndex: newIndex,
        component: newComponent
      });
      dispatch("form_open", newComponent.id);
    }
  }
};
export default design;